// extracted by mini-css-extract-plugin
export default {"blogSection":"BlogSection_blogSection__+vQha","blogTitle":"BlogSection_blogTitle__+Mxwr"};